import React, { useEffect } from 'react'
import moment from 'moment'
import { DEFAULT_RADIO_VALUE, DEFAULT_VALUE, formActionEnum } from '../Config/Constants'
import FormAction from '../Models/FormAction'
import { TemplateObject } from '../Models/TemplateObject'

type Parameters = {
    formData: TemplateObject,
    blankFormData: TemplateObject,
    dispatch: React.Dispatch<FormAction>
}

// const calculateTotal = (
//     quantityFields: NodeListOf<HTMLInputElement>,
//     unitPriceFields: NodeListOf<HTMLInputElement>,
//     formData: TemplateObject,
//     dispatch: React.Dispatch<FormAction>
// ) => {
//     const totalField = document.getElementById("AddMoreTotal") as HTMLInputElement;

//     const handleInputChange = (event: Event) => {
//         const input = event.target as HTMLInputElement;
//         const quantityField = input.getAttribute("id")?.includes("txtQuantity");
//         const unitPriceField = input.getAttribute("id")?.includes("txtUnitPrice");
//         if (quantityField || unitPriceField) {
//             const quantityInput = document.getElementById("txtQuantity") as HTMLInputElement;
//             const unitPriceInput = document.getElementById("txtUnitPrice") as HTMLInputElement;
//             if (quantityInput && unitPriceInput && totalField) {
//                 const quantity = parseFloat(quantityInput.value);
//                 const unitPrice = parseFloat(unitPriceInput.value);
//                 console.log("Quantity:", quantity);
//                 console.log("Unit Price:", unitPrice);

//                 if (!isNaN(quantity) && !isNaN(unitPrice)) {
//                     let total = quantity * unitPrice;
//                     totalField.value = total.toFixed(2);
//                     let updatedFormData = {
//                         ...formData,
//                         txtQuantity: quantity,
//                         txtUnitPrice: unitPrice,
//                         AddMoreTotal: total.toFixed(2),
//                     };
//                     dispatch({ type: formActionEnum.SET_FORM_DATA, payload: updatedFormData });
//                     console.log("Total:", total.toFixed(2));
//                 } else {
//                     console.log("Invalid input for Quantity or Unit Price. Please enter valid numeric values.");
//                 }
//             }
//         }


//     };

//     quantityFields.forEach((quantityField) => {
//         quantityField.addEventListener("input", handleInputChange);
//     });
//     unitPriceFields.forEach((unitPriceField) => {
//         unitPriceField.addEventListener("input", handleInputChange);
//     });
//     return () => {
//         quantityFields.forEach((quantityField) => {
//             quantityField.removeEventListener("input", handleInputChange);
//         });
//         unitPriceFields.forEach((unitPriceField) => {
//             unitPriceField.removeEventListener("input", handleInputChange);
//         });
//     };
// };


const renderFormData = ({ formData, blankFormData }: Parameters) => {
    const tempFormData: TemplateObject = { ...formData }
    const tempBlankFormData: TemplateObject = { ...blankFormData }
    /* update the remove formData keys */
    for (const formKey in tempBlankFormData) {
        const getElements = Array.from(document.getElementsByClassName(formKey)) as HTMLElement[]
        getElements.map(element => {
            if (!formData[formKey]) {
                element.innerHTML = tempBlankFormData[formKey] || ''
                if (element.style && element.style.display) {
                    element.style.display = 'none'
                }
            }
            return element
        })
    }
    for (const formKey in tempFormData) {
        const getElements = Array.from(document.getElementsByClassName(formKey))
        getElements.map(element => {
            // if (!blankFormData[formKey]) {
            //     const tempBlankData = {
            //         [formKey]: element.innerHTML
            //     }
            //     dispatch({ type: formActionEnum.SET_BLANK_FORM_DATA, payload: tempBlankData })
            // }
            const metaKeyName = `meta-data-${formKey}`
            /* conditional text show/hide */
            if (tempFormData[metaKeyName] !== undefined &&
                tempFormData[metaKeyName].selectedValues !== undefined &&
                tempFormData[metaKeyName].selectedValues.constructor.name === 'Array'
            ) {
                let isElementPresent = false
                tempFormData[metaKeyName].selectedValues.forEach((value: TemplateObject) => {
                    if (!value.id.match(/\s/)) {
                        // @ts-ignore: Object is possibly 'null'.
                        const elements: HTMLElement[] | null = document.querySelectorAll(`.${value.id}`)
                        if (elements) {
                            elements.forEach(element => {
                                isElementPresent = true
                                element.style.display = value.style
                            })
                        }
                    }
                })
                if (isElementPresent) { return element }
            }

            /* META DATA HANDLING */
            /* ADD MORE Input Text with separator */
            if (tempFormData[metaKeyName] !== undefined &&
                tempFormData[metaKeyName].addMoreElement === true &&
                tempFormData[metaKeyName].separator !== null
            ) {
                const id = tempFormData[metaKeyName].separatorId
                const values:any = []
                if (!tempFormData[metaKeyName].isGroupAdd) {
                    const inputFields = Object.keys(formData).filter(key => {
                        const re = new RegExp(`^${id}\\d$`, 'g')
                        return key.match(re)
                    })

                    inputFields.forEach(inputId => {
                        if (tempFormData[inputId]) {
                            values.push(tempFormData[inputId])
                        }
                    })
                }
                
                const groupInputFormate = tempFormData[metaKeyName].groupInputFormate
                const signatureFields = tempFormData[metaKeyName].signatureFields
                let moregrpInputs: any = ""
                let firstGrpValues: any = []
                if (tempFormData[metaKeyName].isGroupAdd === true) {
                    const dynamicIndex = tempFormData[metaKeyName].dynamicIndex
                    const children = tempFormData[metaKeyName].children
                    const groupSeparator = tempFormData[metaKeyName].groupInputSeparator
                    if (dynamicIndex) {
                        dynamicIndex.forEach((inputIndex: number) => {
                            const valueMap: string[] = []
                            let childrensCls: any = []
                            children.forEach((inputId: string) => {
                                childrensCls.push(`${inputId}-${inputIndex}`)
                                if (tempFormData[`${inputId}-${inputIndex}`]) {
                                    valueMap.push(tempFormData[`${inputId}-${inputIndex}`])
                                }
                            })
                            if (valueMap.length > 0) {
                                if (groupInputFormate === 'table') {
                                    let moreCol: any = ""
                                    let hasfields:any = [];
                                    if(!!element.getAttribute("data-signatureFields") && signatureFields !== ' '){
                                        let inputSignVal: any = ""
                                        childrensCls.forEach((inputId: string, index: number) => {
                                            let val = !!tempFormData[`${inputId}`] ? tempFormData[`${inputId}`] : ""
                                            signatureFields.forEach((signObj: any) => {
                                                if(signObj.id === inputId.split("-")[0]){
                                                    inputSignVal += '<div class="col-md-6"><span style="min-height: 1.5em;border-bottom:1px solid #000;display:block; padding-bottom: 0px;" class="' + inputId + '" data-signatureFields="yes">'+val+'</span><p style="margin-bottom: 10px;"> ' + signObj.label + '</p></div>';
                                                }
                                                else{
                                                    if(hasfields.indexOf(signObj.id) >= 0){}else{
                                                        moreCol += '<div class="col-md-6"><span style="min-height: 1.5em;border-bottom:1px solid #000;display:block;" class="' + signObj.id + '"></span><p style="margin-bottom: 10px;"> ' + signObj.label + '</p></div>';
                                                    }
                                                }
                                                hasfields.push(signObj.id)
                                            })
                                        })
                                        let tableRow = '<div class="row" style="margin-bottom: 15px;">'+moreCol + inputSignVal+'</div>';
                                        values.push(tableRow);
                                        moregrpInputs += tableRow
                                    }
                                    else{
                                        childrensCls.forEach((inputId: string, index: number) => {
                                            let val = !!tempFormData[`${inputId}`] ? tempFormData[`${inputId}`] : ""
                                            moreCol += '<td><span class="' + inputId + '">' + val + '</span></td>'
                                        })
                                        let tableRow = '<tr class="table-row">' + moreCol + '</tr>'
                                        values.push(tableRow)
                                        moregrpInputs += tableRow
                                    }
                                }
                                else {
                                    values.push(valueMap.join(groupSeparator))
                                }
                            }
                        })
                    }
                }
                
                let modifiedValues = values
                if (tempFormData[metaKeyName].startsWith !== "" && values.length > 0) {
                modifiedValues=[]
                values.forEach((val: string) => {
                    let modiedfield = tempFormData[metaKeyName].startsWith + val + tempFormData[metaKeyName].endsWith;
                    modifiedValues.push(modiedfield)
                });
                }
                if (tempFormData[id]) {
                    let frstUpShiftVal = tempFormData[metaKeyName].endsWith !== "" ? tempFormData[id]+ tempFormData[metaKeyName].endsWith : tempFormData[id]
                    modifiedValues.unshift(frstUpShiftVal)
                }
                if (groupInputFormate === 'table' && modifiedValues.length > 0) {
                    const frstchildren = tempFormData[metaKeyName].children
                    frstchildren.forEach((inputId: string) => {
                        firstGrpValues.push(!!tempFormData[`${inputId}`] ? tempFormData[`${inputId}`] : "")
                    })
                    if(!!element.getAttribute("data-signatureFields")){
                        let elements: any = document.getElementsByClassName(`${id}${'body'}`)
                        let combineCol: any = ""
                        let inputSignVal: any = ""
                        let hasfields:any = [];
                        tempFormData[metaKeyName].children.forEach((inputId: string, index: number) => {
                            signatureFields.forEach((signObj: any) => {
                                if(signObj.id === inputId.split("-")[0]){
                                    inputSignVal += '<div class="col-md-6"><span style="min-height: 1.5em;border-bottom:1px solid #000;display:block; padding-bottom: 0px;" class="' + inputId + '" data-signatureFields="yes">'+firstGrpValues[index]+'</span><p style="margin-bottom: 10px;"> ' + signObj.label + '</p></div>';
                                }
                                else{
                                    if(hasfields.indexOf(signObj.id) >= 0){}else{
                                        combineCol += '<div class="col-md-6"><span style="min-height: 1.5em;border-bottom:1px solid #000;display:block;" class="' + signObj.id + '"></span><p style="margin-bottom: 10px;"> ' + signObj.label + '</p></div>';
                                    }
                                }
                                hasfields.push(signObj.id)
                            })
                            combineCol += '<div class="col-md-6" style="display:none"><span class="' + inputId + '" data-signatureFields="yes">' + firstGrpValues[index] + '</span></div>';
                        })
                        let firstRow = '<div class="row" style="margin-bottom: 15px;">'+combineCol + inputSignVal+'</div>';
                        let finalHtml = firstRow + moregrpInputs;
                        
                        for(let i=0;i<elements.length;i++){
                            if(!!elements[i].getAttribute("data-signatureFields")){
                                elements[i].innerHTML = finalHtml
                            }
                        }
                    }
                    else{

                        let elements: any = document.getElementsByClassName(`${id}${'body'}`)
                        let combineCol: any = ""
                        tempFormData[metaKeyName].children.forEach((inputId: string, index: number) => {
                            combineCol += '<td><span class="' + inputId + '">' + firstGrpValues[index] + '</span></td>'
                        })
                        let firstRow = '<tr class="table-row">' + combineCol + '</tr>'
                        let finalHtml = firstRow + moregrpInputs
                        for(let i=0;i<elements.length;i++){
                            if(!!elements[i].getAttribute("data-signatureFields")){}
                            else{
                                elements[i].innerHTML = finalHtml
                            }
                        }
                        // if (!!elements[0]) {
                        //     elements[0].innerHTML = finalHtml
                        // }
                        // if (!!elements[1]) {
                        //     elements[1].innerHTML = finalHtml
                        // }
                    }
                }
                else {
                    element.innerHTML = modifiedValues.join(tempFormData[metaKeyName].separator) || tempBlankFormData[id] || ''
                }
                return element
            }

            /* update the text if and only if the parent element is selected */
            if (tempFormData[metaKeyName] !== undefined &&
                tempFormData[tempFormData[metaKeyName].id] !== undefined
            ) {
                if (tempFormData[tempFormData[metaKeyName].id].constructor.name === 'String' &&
                    tempFormData[tempFormData[metaKeyName].id] !== tempFormData[metaKeyName].label) {
                    element.innerHTML = ''
                    return element
                }

                if (tempFormData[tempFormData[metaKeyName].id].constructor.name === 'Array' &&
                    !tempFormData[tempFormData[metaKeyName].id].includes(tempFormData[metaKeyName].label)) {
                    /* Checkbox : Add Your Own */
                    if (tempFormData[metaKeyName].checkboxAddYour) {
                        element.innerHTML = tempFormData[formKey] || tempBlankFormData[formKey] || ''
                        return element
                    }

                    element.innerHTML = ''
                    return element
                }
            }
            /* SHOW HIDE ELEMENT BASED UPON THE SELECTED VALUE */
            /* IGNORE : values with spaces  */
            if (tempFormData[metaKeyName] !== undefined &&
                tempFormData[tempFormData[metaKeyName].id] === tempFormData[metaKeyName].label &&
                tempFormData[metaKeyName].showElement &&
                tempFormData[metaKeyName].showElement.match(/\s/) === null) {
                // @ts-ignore: Object is possibly 'null'.
                const elements: HTMLElement[] | null = document.querySelectorAll(`.${tempFormData[metaKeyName].showElement}`)
                // if (elements) {
                //     elements.forEach((element: TemplateObject) => (element.style.display = 'inline-block'))
                // }
            }

            if (tempFormData[metaKeyName] !== undefined &&
                tempFormData[metaKeyName].separator &&
                tempFormData[formKey].constructor.name === 'Array') {
                const separator = tempFormData[metaKeyName].separator
                element.innerHTML = tempFormData[formKey].join(separator)
                return element
            }

            if (tempFormData[metaKeyName] !== undefined &&
                tempFormData[metaKeyName].timeFormat) {
                const timeFormat = tempFormData[metaKeyName].timeFormat
                element.innerHTML = moment(tempFormData[formKey]).format(timeFormat).toString()
                return element
            }
            if ([DEFAULT_RADIO_VALUE, DEFAULT_VALUE].includes(tempFormData[formKey])) {
                element.innerHTML = ''
                return element
            }
            if(!!element.getAttribute("data-emptyline") && tempFormData[formKey] === ""){
                let blankSpace = element.getAttribute("data-emptyline")
                element.innerHTML = !!blankSpace ? blankSpace:""
            }
            else{
                element.innerHTML = tempFormData[formKey] || tempBlankFormData[formKey] || ''
            }

            return element
        })
    }

    // const calculateTotal = () => {
    //     const quantityFields = document.querySelectorAll('input[id*="txtQuantity"]');
    //     const unitPriceFields = document.querySelectorAll('input[id*="txtUnitPrice"]');
    //     const totalField = document.getElementById("AddMoreTotal") as HTMLInputElement;

    //     const handleInputChange = (event: Event) => {
    //         const input = event.target as HTMLInputElement;
    //         const quantityField = input.getAttribute("id")?.includes("txtQuantity");
    //         const unitPriceField = input.getAttribute("id")?.includes("txtUnitPrice");

    //         if (quantityField || unitPriceField) {
    //             const quantityInput = document.getElementById("txtQuantity") as HTMLInputElement;
    //             const unitPriceInput = document.getElementById("txtUnitPrice") as HTMLInputElement;

    //             if (quantityInput && unitPriceInput && totalField) {
    //                 const quantity = parseFloat(quantityInput.value);
    //                 const unitPrice = parseFloat(unitPriceInput.value);
    //                 console.log("Quantity:", quantity);
    //                 console.log("Unit Price:", unitPrice);

    //                 if (!isNaN(quantity) && !isNaN(unitPrice)) {
    //                     let total = quantity * unitPrice;
    //                     totalField.value = total.toFixed(2);
    //                     let updatedFormData = {
    //                         ...formData,
    //                         txtQuantity: quantity,
    //                         txtUnitPrice: unitPrice,
    //                         AddMoreTotal: total.toFixed(2),
    //                     };
    //                     dispatch({ type: formActionEnum.SET_FORM_DATA, payload: updatedFormData });
    //                     console.log("Total:", total.toFixed(2));
    //                 } else {
    //                     console.log("Invalid input for Quantity or Unit Price. Please enter valid numeric values.");
    //                 }
    //             } else {
    //                 console.log("One or more fields not found.");
    //             }
    //         }
    //     };

    //     quantityFields.forEach((field) => {
    //         field.addEventListener("input", handleInputChange);
    //     });

    //     unitPriceFields.forEach((field) => {
    //         field.addEventListener("input", handleInputChange);
    //     });

    //     return () => {
    //         quantityFields.forEach((field) => {
    //             field.removeEventListener("input", handleInputChange);
    //         });
    //         unitPriceFields.forEach((field) => {
    //             field.removeEventListener("input", handleInputChange);
    //         });
    //     };
    // };

    // const removeListeners = calculateTotal();

    // // To remove event listeners when necessary, call the removeListeners function.
    // // For example, if you want to remove the listeners when component unmounts in a React functional component:
    // // useEffect(() => {
    // //     return () => {
    // //         removeListeners();
    // //     };
    // // }, []);

}

export default renderFormData
